import React from 'react'
import { ImageGridLayout, CardGridLayout, RichTextRenderer, H2 } from '../../../lib/components'
import { CMSOpportunityDetailsStrengthsType } from '../../../lib/types'
import { CMSCardTextImageLayout } from './cms-card-text-image-layout'
import { CMS_TEXT_BLOCK_CLASS, CmsSectionText } from './cms-section-text-content'

const CMSStrengths = ({
  strengths,
  testIdPrefix = 'cms-strengths',
}: {
  strengths?: CMSOpportunityDetailsStrengthsType
  testIdPrefix?: string
}) => {
  const renderStrengthsContent = () => {
    const content: JSX.Element[] = []
    if (strengths?.text?.length) {
      content.push(
        <CmsSectionText dataTestId={`${testIdPrefix}-text`} key={`${testIdPrefix}-text`}>
          <RichTextRenderer content={strengths?.text} variant='opportunity-details' />
        </CmsSectionText>,
      )
    }
    if (strengths?.images?.length) {
      content.push(
        <ImageGridLayout
          images={strengths?.images}
          layoutColumns={strengths?.imageLayoutColumns}
          dataTestId={`${testIdPrefix}-section-images`}
          key={`${testIdPrefix}-section-images`}
          splitMiddleColumn={false}
          layoutContainerClasses='opportunity-cms-section-image-layout'
          imageContainerClasses='border-radius-15px'
        />,
      )
    }

    if (strengths?.sectionVariant === 'card-grid') {
      content.push(
        <CardGridLayout
          cardItems={strengths?.strengthItems}
          layoutColumns={strengths?.layoutColumns}
          dataTestId={`${testIdPrefix}-card-grid-content`}
          key={`${testIdPrefix}-card-grid-content`}
          textContentClassName={CMS_TEXT_BLOCK_CLASS}
        />,
      )
    }
    if (strengths?.sectionVariant === 'sectionsWithCards') {
      strengths?.sectionsWithCards?.forEach((section, idx) => {
        if (section?.sectionVariant === 'textCardsLayout') {
          content.push(
            <section
              className={`opportunity-cms-subsection${
                idx > 0 ? ' opportunity-cms-section-spaced-block' : ''
              }`}
              key={`${testIdPrefix}-section-container-${section?.sectionTitle}-${idx}`}
            >
              <H2
                text={section?.sectionTitle}
                id={section?.sectionTitle}
                classes={['opportunity-cms-section-subtitle']}
                dataTestId={`${testIdPrefix}-section-${section?.sectionTitle}-${idx}`}
              />

              <CardGridLayout
                cardItems={section?.strengthItems}
                layoutColumns={section?.layoutColumns}
                dataTestId={`${testIdPrefix}-section-${section?.sectionTitle}-cards-${idx}`}
                key={`${testIdPrefix}-section-${section?.sectionTitle}-cards-${idx}`}
                layoutContainerClasses='opportunity-cms-subsection-content'
                textContentClassName={CMS_TEXT_BLOCK_CLASS}
              />
            </section>,
          )
        }

        if (section?.sectionVariant === 'imageWithTextCard') {
          content.push(
            <section
              className={`opportunity-cms-subsection${
                idx > 0 ? ' opportunity-cms-section-spaced-block' : ''
              }`}
              key={`${testIdPrefix}-section-container-${section?.sectionTitle}-${idx}`}
            >
              <H2
                text={section?.sectionTitle}
                id={section?.sectionTitle}
                classes={['opportunity-cms-section-subtitle']}
                dataTestId={`${testIdPrefix}-section-${section?.sectionTitle}-${idx}`}
              />

              <CMSCardTextImageLayout
                imagePosition={section?.imagePosition}
                image={section?.image}
                cardText={section?.text}
                dataTestId={`${testIdPrefix}-section-${section?.sectionTitle}-image-card-container-${idx}`}
                imageAltText={'Strengths image'}
                layoutContainerClasses='opportunity-cms-subsection-content'
              />
            </section>,
          )
        }
      })
    }
    return content
  }

  return <>{renderStrengthsContent()}</>
}

export { CMSStrengths }
